module.exports = __webpack_public_path__ + "img/cortinas-y-ropa-de-cama.aaef62a1.jpg";